import React from 'react';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Loader from 'features/Loader/Loader';
import Title from 'shared/components/title/Title';
import confirmDiscardChanges from 'shared/components/confirm-discard-changes/confirmDiscardChanges';
import { CUSTOM_REP, METHOD } from 'utils/constants/workouts';
import { createSeriesSchema } from 'utils/validators/workout';
import SeriesStaticForm from './SeriesStaticForm';
import ExerciesList from './Exercies/ExerciesList';
import MethodSection from './MethodSection';
import RepSection from './RepSection';
import {
  getWorkoutWithioutSubs,
  resetUniquenessError,
  resetExerciseModel
} from '../../ducks/workoutActions';

class SeriesForm extends React.Component {
  constructor(props) {
    super(props);
    this.workoutId = props.workoutId;
    if (props.series) {
      this.state = {
        intialExercises: (props.series.exerciseCollection || []).map(
          exercise => exercise.id
        )
      };
    }
  }

  componentDidMount() {
    this.props.getWorkout(this.workoutId, this.props.history);
    this.props.resetUniquenessError();
    this.props.resetExerciseModel();
  }

  render() {
    let {
      workout,
      series,
      history,
      uniquenessError,
      handleSubmit,
      submittingLoading,
      loadingWorkout,
      seriesLoading
    } = this.props;
    const cancelPath = series
      ? `/workouts/${workout.id}/series/${series.id}`
      : `/workouts/${workout.id}`;

    return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          seriesName: series ? series.name : '',
          exerciesNum:
            series && series.exerciseCollection
              ? series.exerciseCollection.length
              : '',
          repsType: series ? (series.is_custom_reps ? CUSTOM_REP : METHOD) : '',
          sets: series ? series.sets : '',
          ExerciesList: series ? series.exerciseCollection : [],
          reps: series && series.reps ? series.reps : '',
          method: series && series.method ? series.method : '',
          deletedExercies: []
        }}
        onSubmit={values => {
          return handleSubmit(
            series ? { ...values, id: series.id } : values,
            this.workoutId,
            history
          );
        }}
        validationSchema={createSeriesSchema}
      >
        {formik => (
          <Form>
            {formik.isSubmitting ||
            submittingLoading ||
            loadingWorkout ||
            seriesLoading ? (
              <Loader />
            ) : (
              <div className="workout">
                <div className="container">
                  <Breadcrumb>
                    <Breadcrumb.Item href="/workouts">Workouts</Breadcrumb.Item>
                    <Breadcrumb.Item href={`/workouts/${workout.id}`}>
                      {workout && workout.name}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Create Series</Breadcrumb.Item>
                  </Breadcrumb>

                  <div className="create-series-form">
                    <Title
                      pageTitle="Create Series"
                      buttonText="Save"
                      linkText="Cancel"
                      cancelLink={cancelPath}
                      cancelBtn={
                        formik.dirty &&
                        (() => confirmDiscardChanges(cancelPath, history))
                      }
                      disabled={formik.isSubmitting}
                    />

                    <SeriesStaticForm
                      exerciseNumField="exerciesNum"
                      repsTypeField="repsType"
                      uniquenessError={
                        !formik.isSubmitting && uniquenessError
                          ? uniquenessError
                          : false
                      }
                      setFieldValue={formik.setFieldValue}
                      values={formik.values}
                      editMood={series && !!series.id}
                    />

                    {formik.values.exerciesNum && (
                      <div className="select-exercies">
                        <ExerciesList
                          values={formik.values}
                          setFieldValue={formik.setFieldValue}
                          exerciesNum={formik.values.exerciesNum}
                        />

                        {typeof formik.errors.ExerciesList === 'string' && (
                          <div className="input-feedback error-bottom-margin">
                            {formik.errors.ExerciesList}
                          </div>
                        )}
                      </div>
                    )}
                    {CUSTOM_REP === formik.values.repsType ? (
                      <RepSection />
                    ) : METHOD === formik.values.repsType ? (
                      <MethodSection
                        method={formik.values.method}
                        setFieldValue={formik.setFieldValue}
                      />
                    ) : null}
                    {formik.values.repsType ? (
                      <div className="input-feedback error-top-margin">
                        {formik.errors.dependentFieldRequired}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            )}
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return {
    workout: state.workoutReducer.workout,
    uniquenessError: state.workoutReducer.uniquenessError,
    submittingLoading: state.workoutReducer.submittingLoading,
    loadingWorkout: state.workoutReducer.loading,
    seriesLoading: state.workoutReducer.seriesLoading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getWorkout: (workoutId, history) =>
      dispatch(getWorkoutWithioutSubs(workoutId, history)),
    resetUniquenessError: () => dispatch(resetUniquenessError()),
    resetExerciseModel: () => dispatch(resetExerciseModel())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SeriesForm);
